module.exports = __webpack_public_path__ + "media/1x1/tv-a595f49d.svg";